<template>
    <div class="p-3">
        <h3>RL 5.3 10 Besar Kunjungan Penyakit Rawat Jalan</h3>
        <hr>
        <DataTable table-id="table-pasien" title="10 Besar Kunjungan Penyakit Rawat Jalan"
            :filter-configs="filterConfigs" :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-morbiditas/10-besar-penyakit-kunjungan-rajal',
                layout: "fitColumns",
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",
                        formatter: "rownum"

                    },
                    {
                        title: "Kelompok ICD-10 ",
                        field: "kode_icd",
                    },
                    {
                        title: "Kelompok Diagnosis Penyakit ",
                        field: "diagnosa",
                    },
                    {
                        title: "Jumlah Kasus Baru Menurut Jenis Kelamin",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "kasus_baru_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "kasus_baru_p",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "total_kasus_baru",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Jumlah Kunjungan ",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "kunjungan_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "kunjungan_p",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "total_kunjungan",
                                hozAlign: "center",
                            }
                        ]
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
